module.exports = __webpack_public_path__ + "static/media/ceo.4390e3ba.svg";